import apiClient, {timeouts} from 'shared/services/apiClient';
import {FileUploadResp} from "shared/types/common";
import pako from "pako";

export const fileService = {
    downloadFile: async (endpoint_url: string, filename: string) => {
        try {
            const response = await apiClient.get(endpoint_url, {responseType: "blob", timeout: timeouts.mediumOperationsTimeout});
            const contentDisposition = response.headers["content-disposition"];

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            return true;
        } catch (error) {
            console.error("Error downloading file:", error);
            return false;
        }
    },
    uploadCompressedFile: async (endpoint_url: string, file: File) => {
        const buffer = await file.arrayBuffer();
        const gzipped = pako.gzip(new Uint8Array(buffer));
        const compressedBlob = new Blob([gzipped], { type: 'application/gzip' });

        const formData = new FormData();
        formData.append("file", compressedBlob, file.name);

        return apiClient
            .post<FileUploadResp>(endpoint_url, formData, {
                headers: { "Content-Encoding": "gzip" },
                timeout: timeouts.complexOperationsTimeout
            })
            .then(r => r.data as FileUploadResp)
            .catch((reason) => ({success: false, f_name: '', rowCount: 0, message: "An error occurred!", errorCode: reason.response?.status ?? reason.request?.status ?? 500
            })
        );
    },
};
